import {
    getSharingLinkInfo,
    onLinkHasChanged,
    SharingLinkInfo,
    updateSharingLinkFromSharingDialog,
} from 'owa-link-data';
import { logUsage } from 'owa-analytics';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { ODBSharingInfo, SharingTipRecipientInfo } from 'owa-sharing-data';
import { lazyOpenSharingDialog, SharingDialogResponse } from 'owa-sharing-dialog';
import { onSharingDialogChangedUrl } from '../actions/internalActions';
import { closeLinkContextMenu } from '../components/LinkContextMenu';

export async function onOpenSharingDialogClicked(
    sharingInfo: ODBSharingInfo,
    linkId: string,
    permissionLevel: AttachmentPermissionLevel,
    composeId: string,
    recipientInfos: SharingTipRecipientInfo[],
    targetWindow: Window
) {
    closeLinkContextMenu();
    const openSharingDialog = await lazyOpenSharingDialog.import();

    const canonicalUrl = sharingInfo.canonicalUrl;
    const endpointUrl = sharingInfo.siteUrl;
    openSharingDialog(endpointUrl, canonicalUrl, sharingInfo.shareId, permissionLevel, targetWindow)
        .then((response: SharingDialogResponse) => {
            const linkHasChanged = response.shareId !== sharingInfo.shareId;
            const sharingLink: SharingLinkInfo = getSharingLinkInfo(linkId);
            const oldLinkUrl: string = sharingLink.url;
            updateSharingLinkFromSharingDialog(linkId, response);

            if (linkHasChanged) {
                const latestSharingLink: SharingLinkInfo = getSharingLinkInfo(linkId);
                onSharingDialogChangedUrl(linkId, oldLinkUrl, latestSharingLink.url);
                onLinkHasChanged(linkId, recipientInfos, composeId);
            } else {
                logUsage('LinkUnchangedFromSharingDialog', { hasResponse: true });
            }
        })
        .catch(error => {
            logUsage('LinkUnchangedFromSharingDialog', { hasResponse: false });
        });
}
